'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List } from 'immutable';
import classNames from 'classnames';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import Professor from 'academy-shared-js/records/Professor';
import ProfessorList from '../LessonPage/ProfessorList';
const BASE_CLASS_NAME = 'lesson-information';

const LessonOverview = ({
  description,
  className,
  professors
}) => /*#__PURE__*/_jsxs("div", {
  className: classNames(BASE_CLASS_NAME, className),
  children: [/*#__PURE__*/_jsx("h4", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.lessonInformation.header"
    })
  }), description, !!professors.size && /*#__PURE__*/_jsx(ProfessorList, {
    className: `${BASE_CLASS_NAME}__professors`,
    i18nHeading: "learningCenter.lessonInformation.professors",
    professors: professors
  })]
});

LessonOverview.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string.isRequired,
  professors: ImmutablePropTypes.listOf(PropTypes.instanceOf(Professor))
};
LessonOverview.defaultProps = {
  className: '',
  professors: List()
};
export default LessonOverview;